'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var cfg = {
  api: {
    baseUrl: '/api',
    selectionsApiUrlTemplate: function selectionsApiUrlTemplate() {
      return "".concat(cfg.api.baseUrl, "/selections");
    }
  }
};
var _default = cfg.api;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/conf.js
// module id = 550
// module chunks = 0